import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IDocument, FileCategory, getFileCategory } from 'src/app/models/document.models';
import { DocumentService } from 'src/app/providers/document/document.service';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentViewerComponent implements OnInit {
  @Input() document: IDocument;
  @Input() eventId: string;

  isImage = false;
  isLoading = true;

  constructor(
    private modalCtrl: ModalController,
    private documentService: DocumentService,
  ) {}

  ngOnInit(): void {
    this.isImage = getFileCategory(this.document?.type) === FileCategory.Image;
    this.isLoading = false;
  }

  close(): void {
    this.modalCtrl.dismiss();
  }

  async download(): Promise<void> {
    await this.documentService.downloadDocument(this.document, this.eventId);
  }

  get safeUrl(): string {
    return this.document?.url || '';
  }
}
